import React, { FC, useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { Button } from 'src/common/components/Button';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { buttonSpacingConfig } from 'src/common/components/Button/config';
import { typographySizeConfig } from 'src/common/styles/typography';
import { CourseEventDisenrollmentConfirmationDialog } from 'src/common/components/CourseEventDisenrollmentConfirmationDialog';
import { AvailabilityStatus, CourseEvent } from 'src/common/models/event';
import { StyleProps } from 'src/lib/styleProps';
import OverflowMenuIcon from 'src/assets/icons/OverflowMenuIcon';
import { colors } from 'src/config/colors';

export interface CourseEventsPanelMenuProps {
  courseTitle: string;
  selectedCourseEvent: CourseEvent;
}

const StyledButton = styled(Button)`
  color: ${colors.blue07};
  align-items: center;
  justify-content: space-between;
  padding: 0 !important;
  margin-left: 0.375rem;

  ${media.w.min.px768(css`
    padding: 0.25rem 1rem !important;
    margin-top: 0.25rem;
    margin-left: 0;

    & svg {
      margin-right: 0.5rem;
    }
  `)}
`;

export const StyledMenuItem = styled(MenuItem)`
  width: 19rem;
  justify-content: center;
  ${typographySizeConfig.default}

  ${media.w.min.px768(css`
    width: auto;
    ${buttonSpacingConfig.default}
    padding-left: 2.8125rem;
    padding-right: 2.8125rem;
  `)}
`;

export const CourseEventsPanelMenu: FC<CourseEventsPanelMenuProps & StyleProps> = ({
  className,
  style,
  selectedCourseEvent,
  courseTitle,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);
  const [isDisenrollmentDialogOpen, setDisenrollmentDialogOpen] = useState<boolean>(false);

  const options: string[] = [];

  if (
    selectedCourseEvent.availabilityStatus === AvailabilityStatus.Pending ||
    selectedCourseEvent.availabilityStatus === AvailabilityStatus.Accepted
  ) {
    options.push('disenrollment');
  }

  if (options.length === 0) {
    return <></>;
  }

  return (
    <>
      {isDisenrollmentDialogOpen && (
        <CourseEventDisenrollmentConfirmationDialog
          courseTitle={courseTitle}
          event={selectedCourseEvent}
          onClose={() => {
            setDisenrollmentDialogOpen(false);
            setAnchorEl(undefined);
          }}
        />
      )}

      <StyledButton
        kind="link"
        onClick={(e) => setAnchorEl((v) => (v ? undefined : e.currentTarget))}
        className={className}
        style={style}
      >
        <OverflowMenuIcon size={18} />
        <span>więcej</span>
      </StyledButton>

      <Menu
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        MenuListProps={{ disablePadding: true }}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
      >
        {options.includes('disenrollment') && (
          <StyledMenuItem onClick={() => setDisenrollmentDialogOpen(true)}>
            Odwołaj swój udział
          </StyledMenuItem>
        )}
      </Menu>
    </>
  );
};
